import PropTypes from 'prop-types';
import { Box, Typography } from '@mui/material';
import { LineChart } from '@mui/x-charts/LineChart';
import usePanelSize from '../../hooks/usePanelSize';
import i18n, { t } from '../../i18n';

export default function EvolutionChart({ data, metric, title, color = '#103B66', description = 'Totais no final de cada mês' }) {
    const frame = usePanelSize();
    const locale = i18n.resolvedLanguage === 'en' ? 'en-GB' : 'pt-PT';
    const month = new Intl.DateTimeFormat(locale, { month: 'short', year: '2-digit', timeZone: 'UTC' });
    const number = new Intl.NumberFormat(locale);
    return <Box sx={{ height: '100%', minHeight: 0, display: 'flex', flexDirection: 'column' }}>
        <Typography variant="h4" component="h2" color="primary.main" noWrap sx={{ fontSize: { xs: 15, sm: 17 } }}>
            {t(title)}
        </Typography>
        <Typography variant="caption" color="text.secondary" sx={{ mt: 0.5, fontSize: 11, '@media (max-height:499.95px)': { display: 'none' } }}>
            {t(description)}
        </Typography>
        <Box ref={frame.ref} role="img" aria-label={t(title)} sx={{ flex: 1, minHeight: 0, minWidth: 0 }}>
            <LineChart height={Math.max(40, frame.height)}
                xAxis={[{
                    scaleType: 'point', data: data.map((item) => item.month),
                    valueFormatter: (value) => month.format(new Date(value + 'T00:00:00Z')),
                    tickLabelStyle: { fontSize: 10 },
                    tickLabelInterval: (_, index) => frame.width >= 400 || index % 2 === 0 || index === data.length - 1
                }]}
                yAxis={[{ min: 0, tickMinStep: 1, tickNumber: frame.height < 160 ? 3 : 5,
                    tickLabelInterval: frame.height < 110 ? () => false : undefined,
                    disableLine: frame.height < 110, disableTicks: frame.height < 110,
                    valueFormatter: (value) => number.format(value) }]}
                series={[{
                    data: data.map((item) => item[metric]), label: t(title), color, curve: 'linear',
                    area: true, showMark: false, valueFormatter: (value) => value == null ? '—' : number.format(value)
                }]}
                grid={{ horizontal: true }}
                margin={frame.height < 110 ? { left: 8, right: 8, top: 6, bottom: 22 } : { left: 42, right: 12, top: 14, bottom: 28 }}
                slotProps={{ legend: { hidden: true } }}
                sx={{
                    '& .MuiAreaElement-root': { fillOpacity: 0.08 },
                    '& .MuiLineElement-root': { strokeWidth: 2.5 },
                    '& .MuiChartsAxis-tickLabel': { fill: '#53636F' },
                    '& .MuiChartsGrid-line': { stroke: '#EEF1F3' }
                }}
            />
        </Box>
    </Box>;
}
EvolutionChart.propTypes = {
    data: PropTypes.arrayOf(PropTypes.object).isRequired, metric: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired, color: PropTypes.string, description: PropTypes.string
};
